'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});


var ACTION_TYPES = {
    SET_LANGUAGE_KEY: '@i18n/SET_LANGUAGE_KEY',
    SET_LANGUAGE_LIST: '@i18n/SET_LANGUAGE_LIST',
    SET_TRANSLATION_LIST: '@i18n/SET_TRANSLATION_LIST',
    UPDATE_TRANSLATION_LIST: '@i18n/UPDATE_TRANSLATION_LIST'
};

exports.ACTION_TYPES = ACTION_TYPES;